// # when ever the user register
export const USER_REGISTER_REQUEST = "USER_REGISTER_REQUEST";
export const USER_REGISTER_SUCCESS = "USER_REGISTER_SUCCESS";
export const USER_REGISTER_FAIL = "USER_REGISTER_FAIL";
export const USER_REGISTER_RESET = "USER_REGISTER_RESET";

// # when ever user verify the otp
export const USER_VERIFY_REQUEST = "USER_VERIFY_REQUEST";
export const USER_VERIFY_SUCCESS = "USER_VERIFY_SUCCESS";
export const USER_VERIFY_FAIL = "USER_VERIFY_FAIL";
export const USER_VERIFY_RESET = "USER_VERIFY_RESET";
export const USER_VERIFY_DESTROY = "USER_VERIFY_DESTROY";

// # when ever the user login
export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL";

export const USER_LOGOUT_SUCCESS = "USER_LOGOUT_SUCCESS";
export const USER_LOGOUT_FAIL = "USER_LOGOUT_FAIL";
export const USER_LOGOUT_RESET = "USER_LOGOUT_RESET";

export const USER_DETAIL_SUCCESS = "USER_DETAIL_SUCCESS";
export const USER_DETAIL_FAIL = "USER_DETAIL_FAIL";

export const UPDATE_USER_DETAIL_REQUEST = "UPDATE_USER_DETAIL_REQUEST";
export const UPDATE_USER_DETAIL_SUCCESS = "UPDATE_USER_DETAIL_SUCCESS";
export const UPDATE_USER_DETAIL_FAIL = "UPDATE_USER_DETAIL_FAIL";
export const UPDATE_USER_DETAIL_RESET = "UPDATE_USER_DETAIL_RESET";

export const SOCAIL_AUTH_SUCCESS = "SOCAIL_AUTH_SUCCESS";
export const SOCAIL_AUTH_FAIL = "SOCAIL_AUTH_FAIL";

export const ADMIN_ALL_USERS_REQUEST = "ADMIN_GET_USERS_REQUEST";
export const ADMIN_ALL_USERS_SUCCESS = "ADMIN_GET_USERS_SUCCESS";
export const ADMIN_ALL_USERS_FAIL = "ADMIN_GET_USERS_FAIL";

// # clearing the errors
export const USER_CLEAR_ERRORS = "USER_CLEAR_ERRORS";
export const USER_CLEAR_ERRORS_2 = "USER_CLEAR_ERRORS_2";

// purchases
export const MY_USER_PURCHASE_REQUEST = "MY_USER_PURCHASE_REQUEST";
export const MY_USER_PURCHASE_SUCCESS = "MY_USER_PURCHASE_SUCCESS";
export const MY_USER_PURCHASE_FAIL = "MY_USER_PURCHASE_FAIL";
